module.exports = __webpack_public_path__ + "img/slide6-ru.cfb02920.png";